import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

const baseApiURL = 'https://api.ibcgp.org.br'; //'http://127.0.0.1:2500'
axios.defaults.baseURL = baseApiURL

// Tornar o axios acessível globalmente
Vue.prototype.$axios = axios;

// Verificar o domínio atual e redirecionar se for o subdomínio concursos.ibcgp.org.br
if (window.location.hostname === 'concursos.ibcgp.org.br' && window.location.pathname !== '/concursos') {
  window.location.href = '/concursos';
}

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
